import { useState } from "react";


export default function Accordion({ items,primaryFontColor,primaryColor }) {
  const [openKeys, setOpenKeys] = useState(
    items[0]?.key ? [items[0].key] : []
  );

  const toggle = (key) => {
    setOpenKeys(prev => 
      prev.includes(key)
        ? prev.filter(k => k !== key) // close
        : [...prev, key] // open (keep others open)
    );
  };


  return (
    <div className="accordion">
      {items.map((item) => {
        const isOpen = openKeys.includes(item.key);

        return (
          <div key={item.key} className="acc-item">
            <button
              className={`acc-header ${isOpen ? "open" : ""}`}
              onClick={() => toggle(item.key)}
              style={{backgroundColor:primaryColor,color:primaryFontColor}}
            >
              {item.title}

              <span className={`acc-arrow ${isOpen ? "rotate" : ""}`}>
                ▼
              </span>
            </button>

            <div className={`acc-body ${isOpen ? "show" : ""}`}>
              <div className="acc-content">
                {item.content}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}